/**
 * Service de récupération des données PMSI de démonstration
 */

import { apiClient } from '@/shared/services/apiClient';
import { API_ENDPOINTS } from '@/config/api';
import type { PmsiData } from '@/shared/types/pmsi';

export const demoService = {
  getPmsi: (): Promise<PmsiData> =>
    apiClient.get<PmsiData>(API_ENDPOINTS.demoPmsi),
};
